// Length limit for long text answer
export const ANSWER_LONG_TEXT_LIMIT = 60
